module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/img_webinar_08-5e581eed79d591b94c3f7ca43545230b.png";